module.exports = __webpack_public_path__ + "img/error.961ecb74.svg";